import React from "react";

import Grid from "../../../layout/grid/grid";

export class InputLabel extends React.PureComponent {
	state = {
		type: this.props.type
	}

	changeType = () => {
		if(this.state.type === this.props.iconChangeType[0]) {
			this.setState({
				type: this.props.iconChangeType[1]
			});
		} else {
			this.setState({
				type: this.props.iconChangeType[0]
			});
		}
	}

	render() {
		const {
			meta: { touched, error },
			inputClass, iconStyle,
			reference
		} = this.props;
		const iconSide = (this.props.iconRight ? {right: 10} : {left: 0})
		const topLabel = (this.props.label ? {top: 70} : {})
		return (
			<Grid cols={this.props.cols} style={{paddingBottom: '1.2rem', ...this.props.style}}>
				<div
					className={`form-group ${touched && error && "has-error"}`}
				>
					{this.props.label ?
						touched && error ? (
							<label className="control-label">
								<i className="fa fa-times-circle-o" />
								&nbsp;
								{this.props.label}
							</label>
						) : (
							<label htmlFor={this.props.name}>
								{this.props.label}
							</label>
						)
					: null
					}
					{this.props.icon 
					? (
						<div style={{position: 'relative'}}>
							<input
								{...this.props.input}
								ref={reference}
								style={{...this.props.inputStyle, padding: '2rem 2rem 2rem 5rem'}}
								className={"form-control " + inputClass}
								placeholder={this.props.placeholder}
								readOnly={this.props.readOnly}
								type={this.state.type}
							/>
							<i
								className={this.props.icon + ' input--icon'}
								onClick={this.props.iconChangeType ? this.changeType : this.props.iconClick}
								style={{...iconSide, ...iconStyle}}
							></i>
						</div>
					)
					: (
						<input
							{...this.props.input}
							ref={reference}
							style={this.props.inputStyle}
							className={"form-control " + inputClass}
							placeholder={this.props.placeholder}
							readOnly={this.props.readOnly}
							type={this.props.type}
						/>
					)
					}
					{touched && error && (
						<span className="help-block" style={topLabel}>{error}</span>
					)}
				</div>
			</Grid>
		);
	}
}